import React from 'react';
import { Table } from 'react-bootstrap';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { PaymentTypes } from '../payments/actions';
import Card from '../../common/components/Card';
import utils from '../../common/services/utils';

const View = ({ payment, enableUserTimeZone, t }) => {
    const { child, center, consultationDate, consultationType } = payment;

    return (
        <Card color='green'>
            <h4><Link to={`/payment-history/${payment.id}/${PaymentTypes.IndividualConsultation}`} className='no-decoration'>{t('FO_Payment_Id')}{payment.id}</Link></h4>
            <h4><CenterDetailsLink center={center} /></h4>
            <h4 className='text-muted'>{(enableUserTimeZone ? utils.convertToUserTime(consultationDate, center) : moment(consultationDate)).format('lll')}</h4>
            <div style={{ fontSize: 28, marginTop: 10 }}>{t(`IndividualConsultationType_${consultationType}`)}</div>
            <div style={{ fontSize: 20, marginTop: 10 }}>{child && child.fullName}</div>
        </Card>
    );
};

export default withTranslation()(View);